import { DateTime } from 'luxon';

/** Duração humanizada — dias/horas/minutos, mostrando só as unidades relevantes. */
export function formatDurationHuman(from: DateTime, to: DateTime): string {
    const totalMinutes = Math.max(0, Math.round(to.diff(from, 'minutes').minutes));
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    const parts: string[] = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || !parts.length) parts.push(`${minutes}min`);
    return parts.join(' ');
}

/**
 * Tooltip multi-linha (Nome / Início / Fim (se fechado) / Duração) para uma
 * alocação real — usado nas barras de /shifts/allocations e no widget de
 * equipe remota. As linhas são separadas por `\n`; o elemento precisa de
 * `matTooltipClass` com `white-space: pre-line` para exibir corretamente.
 */
export function buildAllocationTooltip(
    name: string,
    startAt: string | Date,
    endAt: string | Date | null,
    timezone: string,
    now: Date = new Date(),
    roleLabel?: string | null,
): string {
    const start = DateTime.fromJSDate(new Date(startAt), { zone: timezone });
    const end = endAt ? DateTime.fromJSDate(new Date(endAt), { zone: timezone }) : null;
    const nowDt = DateTime.fromJSDate(now, { zone: timezone });

    const lines = [roleLabel ? `${name} — ${roleLabel}` : name, `Início: ${start.toFormat('dd/MM/yyyy HH:mm')}`];
    if (end) {
        lines.push(`Fim: ${end.toFormat('dd/MM/yyyy HH:mm')}`);
        lines.push(`Duração: ${formatDurationHuman(start, end)}`);
    } else {
        lines.push(`Duração: ${formatDurationHuman(start, nowDt)}`);
    }
    return lines.join('\n');
}
